import { useEffect, useRef } from 'react'

export default function usePageView(trackView) {
  const hasFiredRef = useRef(false)

  useEffect(() => {
    if (hasFiredRef.current) return
    if (typeof trackView !== 'function') return
    hasFiredRef.current = true
    trackView()
  }, [trackView])
}
